const NEW = -1;
const ACTIVE = 1;
const PENDING = 2;
//const PENDING_PAYMENT = 3;
//const PAID            = 4;
//const DELIVERED       = 5;
const COMPLETED = 8;
const CLOSED = 11;
const SUSPENDED = 20;
const CANCELLED = 21;
//const EXPIRED         = 22;
const REJECTED = 23;

export const convertUrlSocialMedia = (social, user) => {
  switch (social) {
    case "facebook":
      return "https://facebook.com/" + user;
    case "instagram":
      return "https://www.instagram.com/" + user;
    case "twitter":
      return "https://twitter.com/" + user;
    case "youtube":
      return "https://www.youtube.com/" + user;
    default:
      return "http://ola.id";
  }
};
/**/

export const dataStatusTransfer = [
  { id: NEW, name: "New" },
  { id: PENDING, name: "Pending" },
  { id: COMPLETED, name: "Completed" },
  { id: CANCELLED, name: "Cancelled" },
  { id: REJECTED, name: "Rejected" }
];

export const getStatusTransfer = status => {
  let StatusName = "";
  switch (status) {
    case NEW:
      StatusName = "New";
      break;
    case PENDING:
      StatusName = "Pending";
      break;
    case COMPLETED:
      StatusName = "Completed";
      break;
    case CANCELLED:
      StatusName = "Cancelled";
      break;
    case REJECTED:
      StatusName = "Rejected";
      break;
    default:
      StatusName = "";
  }
  return StatusName;
};

export const dataStatusMarketer = [
  { id: ACTIVE, name: "Active" },
  { id: CANCELLED, name: "Cancelled" },
  { id: CLOSED, name: "Closed" },
  { id: COMPLETED, name: "Completed" },
  { id: PENDING, name: "Pending" },
  { id: REJECTED, name: "Rejected" },
  { id: SUSPENDED, name: "Suspended" }
];

export const getStatusMarketer = status => {
  let StatusName = "";
  switch (status) {
    case ACTIVE:
      StatusName = "Active";
      break;
    case CANCELLED:
      StatusName = "Cancelled";
      break;
    case CLOSED:
      StatusName = "Closed";
      break;
    case COMPLETED:
      StatusName = "Completed";
      break;
    case PENDING:
      StatusName = "Pending";
      break;
    case REJECTED:
      StatusName = "Rejected";
      break;
    case SUSPENDED:
      StatusName = "Suspended";
      break;
    default:
      StatusName = "";
  }
  return StatusName;
};

export const datify = input => {
  if (!input) {
    return null;
  }

  const date = input instanceof Date ? input : new Date(input);
  if (isNaN(date)) {
    throw new Error(`Invalid date: ${input}`);
  }
  let date2 = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  return year + "/" + month + "/" + date2;
};

export const dataCategory = [
  { id: "fashion", name: "Fashion" },
  { id: "beauty", name: "Beauty" },
  { id: "travel", name: "Travel" },
  { id: "food", name: "Food" },
  { id: "lifestyle", name: "Lifestyle" },
  { id: "fitness", name: "Fitness" },
  { id: "gadget", name: "Gadget" },
  { id: "health", name: "Health" },
  { id: "comedy", name: "Comedy" },
  { id: "music", name: "Music" },
  { id: "movie", name: "Movie" },
  { id: "automotive", name: "Automotive" },
  { id: "model", name: "Model" },
  { id: "photography", name: "Photography" },
  { id: "designer", name: "Designer" }
];

export const marketerDefaultValue = {
  social: {
    instagram: {
      id: "",
      followers: 0
    },
    facebook: {
      id: "",
      followers: 0
    },
    twitter: {
      id: "",
      followers: 0
    },
    youtube: {
      id: "",
      followers: 0
    },
    profile: ""
  }
};

export const checkNumber = v => {
  if (v.length > 0) {
    return isNaN(v) ? undefined : parseFloat(v);
  }
  return isNaN(v) ? 0 : v;
};



// WEBPACK FOOTER //
// ./src/marketers/utilsMarketer.js